<div
  class="nested-item-content-header"
  (click)="onCloseLanguageBar()">
  <ui-icon
    class="chevron"
    key="chevron-left"></ui-icon>
  <a>{{ 'translation-content-wizard.language' | transloco }}</a>
</div>

<div class="nested-item-content-list nested-item-content-languages">
  <a
    *ngFor="let language of languageService.languageKeys"
    (click)="chooseLanguage(language)">
    <sh-main-nav-language-flag [code]="language"></sh-main-nav-language-flag>
    {{ 'language.' + language | transloco }}
  </a>
</div>
